import { useQuery } from 'react-query';

import Purser from '~/utils/Purser';

async function getPurserData() {
  const purser = await Purser();

  return await purser.fetch();
}

export default function usePurser() {
  return useQuery('purser', getPurserData, {
    suspense: true,
  });
}
